<template>
  <div>
    <el-dialog title="Añadir motivo de ausencia" :visible.sync="dialogVisible" :before-close="handleCancel">
      <el-row :gutter="20">
        <el-input v-model="description" :rows="5" type="textarea" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel()">Cancelar</el-button>
        <el-button type="primary" @click="handleSubmit()">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    props: ['dialogVisible','absenceId'],
    data() {
      return {
        description: '',
      }
    },
    created() {
      this.fetchAbsence();
    },
    methods: {
      fetchAbsence() {
        axios.get(`absences/${this.absenceId}/show-json`)
        .then(res => {
          console.log(res.data);
          this.description = res.data.description;
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      handleSubmit() {
        axios.put(`absences/${this.absenceId}/update-json`, {
          'description': this.description,
        })
        .then(res => {
          this.$message({
            message: res.data,
            type: 'success',
            duration: 5000,
          });
          this.handleCancel();
        })
        .catch(e => {
          console.log(e.response);
        })
      },
      handleCancel(done) {
        this.$emit('dialogVisible', false);
      },
    },
  }
</script>
<style scoped>
  .v-modal {
    z-index: 0 !important;
  }
</style>